/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
    FETCH_IDS_DETAILS_REQUEST,
    FETCH_IDS_DETAILS_SUCCESS,
    FETCH_IDS_DETAILS_FAILURE,
} from "./IdsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchIdsDetailsRequest = () => {
  return {
    type: FETCH_IDS_DETAILS_REQUEST,
  };
};

export const fetchIdsDetailsSuccess = (idsData) => {
  return {
    type: FETCH_IDS_DETAILS_SUCCESS,
    payload: idsData,
  };
};

export const fetchIdsDetailsFailure = (error) => {
  return {
    type: FETCH_IDS_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchIdsDetails = (forceRefresh = false) => {
  return async function (dispatch, getState) {
    // Check if data is already being fetched or already exists
    const currentState = getState();
    const { loading, ids } = currentState.idsDetails;
    
    // Don't fetch if already loading, or if data already exists (unless force refresh is requested)
    if (loading) {
      console.log('IDS data already loading, skipping API call');
      return;
    }
    
    if (!forceRefresh && ids && ids.length > 0) {
      console.log('IDS data already exists, skipping API call. Use forceRefresh=true to override.');
      return;
    }

    dispatch(fetchIdsDetailsRequest());
    try {
      const data = await APIManager.getIds();
      dispatch(fetchIdsDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchIdsDetailsFailure(error));
      dispatch(commonError(error, FETCH_IDS_DETAILS_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
